import api, { getApiError } from "@/api";

export async function getServerConfig() {
  const { data, error } = await api.GET("/api/v1/server-config");
  if (error || !data) {
    throw getApiError(error);
  }
  return data;
}
